import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/**
 * `/$tenant/triggers` — entrée « Déclencheurs » hors projet : redirige vers
 * `/$tenant/projects/$projectId/triggers` (un déclencheur est porté par un projet au contrat).
 */
export const Route = createFileRoute('/$tenant/triggers/')({ component: TriggersRoute });

function TriggersRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="triggers" crumbs={[{ label: t('nav.items.triggers') }]}>
      <ProjectResolver tenantId={tenant} section="triggers" />
    </ConsoleShell>
  );
}
